module.exports = __webpack_public_path__ + "static/img/shipinhuiyi2.26ffa5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/shipinhuiyi2.png
// module id = YZ2B
// module chunks = 24